import { MenuItems, Transition } from "@headlessui/react";

import styles from './DropdownItems.module.css';
import { Fragment } from "react";

interface Props {
    alignment?: 'left'|'right'
    children: React.ReactNode;
}

const DropdownItems = ({ alignment = "left", children }: Props) => {

    return (
        <Transition
            as={Fragment}
            enter="transition ease-out duration-150"
            enterFrom="transform opacity-0 translate-y-[-0.5rem]"
            enterTo="transform opacity-100 translate-y-[0rem]"
            leave="transition ease-in duration-100"
            leaveFrom="transform opacity-100 translate-y-[0rem]"
            leaveTo="transform opacity-0 translate-y-[-0.5rem]"
        >
            <MenuItems className={`${styles.DropdownItems} ${(alignment === "right") ? styles.DropdownItemsRight : ''}`}>{children}</MenuItems>
        </Transition>
    )

}

export default DropdownItems;
